var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyrightSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:copyright"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3C7.1211 3 3 7.122 3 12C3 16.878 7.1211 21 12 21C16.8789 21 21 16.878 21 12C21 7.122 16.8789 3 12 3ZM12 14.7C12.8928 14.7 13.665 14.4615 14.0637 14.0628L15.3363 15.3363C14.3229 16.3488 12.8109 16.5 12 16.5C9.5187 16.5 7.5 14.4813 7.5 12C7.5 9.5187 9.5187 7.5 12 7.5C12.8109 7.5 14.3238 7.6512 15.3363 8.6637L14.0637 9.9363C13.6659 9.5376 12.8937 9.3 12 9.3C10.5366 9.3 9.3 10.5366 9.3 12C9.3 13.4634 10.5366 14.7 12 14.7Z",
    fill: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightSvg);
export default __webpack_public_path__ + "static/media/CopyrightSVG.f96b966967862628b193e8604363f9b0.svg";
export { ForwardRef as ReactComponent };